var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "page-wrap" },
    [
      _c(
        "filter-search",
        {
          attrs: { list: _vm.filterSearchList, fromdata: _vm.formData },
          on: { Refresh: _vm.onHandleRefresh, search: _vm.onHandleSearch },
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onHandleCreate },
                },
                [_vm._v(" 新增 ")]
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "warning",
                    icon: "el-icon-download",
                    disabled: !_vm.tableData.length || _vm.disabledExport,
                  },
                  on: { click: _vm.onHandleExport },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("section", { staticClass: "summary" }, [
        _vm._v(" 总退款金额："),
        _c("strong", [_vm._v(_vm._s(_vm.refundTotal.toFixed(2)))]),
        _vm._v(" 元 "),
      ]),
      _c(
        "section",
        { staticClass: "content" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: "",
                "header-cell-style": { color: "#333", background: "#EFF6FF" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplier_name",
                  label: "供应商名称",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistic_business_name",
                  label: "集配中心",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: "添加时间",
                  width: "110",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operate_name",
                  label: "添加人",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "扣款金额",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "check_operate_name",
                  label: "审核人",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deduction_type_txt",
                  label: "扣款类型",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "as_no",
                  label: "售后单号",
                  "min-width": "130",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "order_no",
                  label: "订单号",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "商品名称", "min-width": "110" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "trade_no",
                  label: "退款流水号",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deduction_state_txt",
                  label: "扣款状态",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "check_state_txt",
                  label: "审核状态",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "check_time",
                  label: "扣款时间",
                  width: "110",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleView(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        scope.row.is_audit == "1"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleAudit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                        scope.row.is_audit == "1"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleCancel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("作废")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.formData.page,
              "page-size": _vm.formData.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              attrs: {
                model: _vm.dialogData,
                rules: _vm.dialogRules,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "扣款类型" } },
                [
                  _c("el-input", {
                    attrs: { value: "平台客诉", disabled: "" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单号", prop: "order_no" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.dialogReadonly,
                      placeholder: "输入订单号",
                    },
                    on: { blur: _vm.getGoodsList },
                    model: {
                      value: _vm.dialogData.order_no,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogData, "order_no", $$v)
                      },
                      expression: "dialogData.order_no",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "order_detail_id" } },
                [
                  _vm.dialogReadonly
                    ? _c("el-input", {
                        attrs: {
                          value: _vm.dialogData.title,
                          disabled: "",
                          placeholder: "商品名称",
                        },
                      })
                    : _c(
                        "el-select",
                        {
                          attrs: { placeholder: "选择商品名称" },
                          on: { change: _vm.onGoodsChange },
                          model: {
                            value: _vm.dialogData.order_detail_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogData, "order_detail_id", $$v)
                            },
                            expression: "dialogData.order_detail_id",
                          },
                        },
                        _vm._l(_vm.goodsList, function (item) {
                          return _c("el-option", {
                            key: item.order_detail_id,
                            attrs: {
                              label: item.title,
                              value: item.order_detail_id,
                            },
                          })
                        }),
                        1
                      ),
                ],
                1
              ),
              _vm.remainInfo
                ? _c("el-form-item", { attrs: { label: "" } }, [
                    _c("div", { staticClass: "remain-tip" }, [
                      _vm._v(" " + _vm._s(_vm.remainInfo) + " "),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "金额", prop: "amount" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.dialogReadonly,
                      type: "number",
                      placeholder: "输入金额",
                    },
                    model: {
                      value: _vm.dialogData.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogData, "amount", $$v)
                      },
                      expression: "dialogData.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": "",
                      disabled: _vm.dialogReadonly,
                      placeholder: "输入备注",
                    },
                    model: {
                      value: _vm.dialogData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogData, "remark", $$v)
                      },
                      expression: "dialogData.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "相关证明" } },
                [
                  _c("b-file-upload", {
                    attrs: {
                      accepts: ["jpg", "jpeg", "png"],
                      limit: 5,
                      disabled: _vm.dialogReadonly,
                    },
                    model: {
                      value: _vm.picList,
                      callback: function ($$v) {
                        _vm.picList = $$v
                      },
                      expression: "picList",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              !_vm.dialogReadonly
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onHandleSave },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }